module.exports = __webpack_public_path__ + "static/media/dia-dos-finados.bd5332fa.png";